import React from "react";
import { SearchOutlined, EnvironmentOutlined } from "@ant-design/icons";
import { Flex, Input, Typography, Button } from "antd";
import { useTranslation } from "react-i18next";

import {
  StyledHeroSection,
  HeroContainer,
  HeroTitle,
  HeroTitleHighlight,
  HeroSubtitle,
  SearchContainer,
  SearchDivider,
  PopularSearches,
} from "./HeroSection.styles";
import { SectionContentWrapper } from "../../styled";

export const HeroSection: React.FC = () => {
  const { t } = useTranslation();

  return (
    <StyledHeroSection>
      <SectionContentWrapper>
        <HeroContainer>
          <HeroTitle>
            {t("home.hero.title")}
            <br />
            <HeroTitleHighlight>{t("home.hero.titleHighlight")}</HeroTitleHighlight>
          </HeroTitle>
          <HeroSubtitle>{t("home.hero.subtitle")}</HeroSubtitle>

          <SearchContainer>
            <Flex vertical style={{ flex: 1 }}>
              <Input
                type="text"
                variant="borderless"
                placeholder={t("home.hero.searchService")}
                size="large"
                prefix={<SearchOutlined style={{ color: "#9CA3AF", marginRight: 8 }} />}
                style={{ fontSize: 16 }}
              />
            </Flex>
            <SearchDivider />
            <Flex vertical style={{ flex: 1 }}>
              <Input
                type="text"
                variant="borderless"
                placeholder={t("home.hero.searchLocation")}
                size="large"
                prefix={<EnvironmentOutlined style={{ color: "#9CA3AF", marginRight: 8 }} />}
                style={{ fontSize: 16 }}
              />
            </Flex>
            <Button
              type="primary"
              size="large"
              style={{
                height: 56,
                paddingInline: 32,
                fontWeight: 600,
                boxShadow: "0 4px 14px rgba(108, 92, 231, 0.3)",
                borderRadius: 28,
              }}
            >
              {t("home.hero.searchButton")}
            </Button>
          </SearchContainer>

          <PopularSearches>
            <Typography.Text type="secondary">{t("home.hero.popular")}</Typography.Text>
            <Typography.Link style={{ color: "#6C5CE7" }}>{t("home.hero.popularItem1")}</Typography.Link>
            <Typography.Link style={{ color: "#6C5CE7" }}>{t("home.hero.popularItem2")}</Typography.Link>
            <Typography.Link style={{ color: "#6C5CE7" }}>{t("home.hero.popularItem3")}</Typography.Link>
          </PopularSearches>
        </HeroContainer>
      </SectionContentWrapper>
    </StyledHeroSection>
  );
};
